import React from 'react';
import ReactDOM from 'react-dom/client'; // Import the new client API
import { BrowserRouter } from 'react-router-dom';
import App from './App'; // Import your main app component

// Wrap the App component with BrowserRouter for routing
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
